import { actions } from "./orderConstants";

/**
 * The "general data" step's form state, shared by BOTH launch flows (the RFQ
 * builder and launch-from-PR). Kept as a reducer (not RHF) because it is one of
 * the two sources the byte-equivalent create/edit payload is built from
 * (buildOrderPayload / buildRequestOrderPayload): migrating it to a second form
 * library would fork that source of truth. Extracted verbatim from the pre-Carbon
 * Order.tsx; the `UPDATE_FILES` case (whole-array set) is used only by the PR
 * prefill and is a no-op for the RFQ builder, which never dispatches it.
 */
export const generalBidReducer = (state: any, action: any) => {
  let newEvent = { ...state };
  switch (action.type) {
    case actions.UPDATE_NAME:
      newEvent = { ...newEvent, name: action.name };
      break;
    case actions.UPDATE_INTERNAL_CODE:
      newEvent = { ...newEvent, internalCode: action.internalCode };
      break;
    case actions.UPDATE_START_DATE:
      newEvent = {
        ...newEvent,
        startDateValue: action.startDateValue,
        endDateValue: "",
      };
      break;
    case actions.UPDATE_FINISH_DATE:
      newEvent = { ...newEvent, endDateValue: action.endDateValue };
      break;
    case actions.UPDATE_START_TIME:
      newEvent = { ...newEvent, startTimeValue: action.startTimeValue };
      break;
    case actions.UPDATE_FINISH_TIME:
      newEvent = { ...newEvent, endTimeValue: action.endTimeValue };
      break;
    case actions.UPDATE_CONSULTATION_START:
      newEvent = {
        ...newEvent,
        consultationStartValue: action.consultationStartValue,
        consultationEndValue: "",
      };
      break;
    case actions.UPDATE_CONSULTATION_END:
      newEvent = {
        ...newEvent,
        consultationEndValue: action.consultationEndValue,
      };
      break;
    case actions.UPDATE_EXPIRE_DATE:
      newEvent = { ...newEvent, expireDate: action.expireDate };
      break;
    case actions.UPDATE_BUYER_PICKS_UP:
      newEvent = { ...newEvent, buyerPicksUp: action.buyerPicksUp };
      break;
    case actions.UPDATE_PAYMENT_METHOD:
      newEvent = { ...newEvent, paymentMethod: action.paymentMethod };
      break;
    case actions.UPDATE_PAYMENT_TERM:
      newEvent = { ...newEvent, paymentTerm: action.paymentTerm };
      break;
    case actions.UPDATE_COMMENT:
      newEvent = { ...newEvent, comment: action.comment };
      break;
    case actions.UPDATE_FILES:
      newEvent = { ...newEvent, files: action.files };
      break;
    case actions.UPDATE_INCOTERM:
      newEvent = { ...newEvent, incoTerm: action.incoTerm };
      break;
    case actions.UPDATE_CURRENCY:
      newEvent = { ...newEvent, currency: action.currency };
      break;
    case actions.ADD_FILE:
      newEvent = { ...newEvent, files: [...newEvent.files, ...action.files] };
      break;
    case actions.REMOVE_FILE:
      newEvent = {
        ...newEvent,
        files: newEvent.files.filter(
          (_: any, index: number) => index !== action.index
        ),
      };
      break;
  }
  return newEvent;
};
